import type { GlobalerFilterData } from "@/lib/models/globalerFilterApi";
import type { Notification } from "@/lib/models/notifications";

interface ApiEndpoints {
	readonly artikelauswahl: string;
	readonly artikelauswahlPreis: string;
	readonly warenkorb: string;
	readonly warenkorbOverlay: string;
	readonly warenkorbGetAnzahlPositionen: string;
	readonly shareCart: string;
	readonly downloadStep: string;
	readonly produktEmpfehlen: string;
	readonly cadSchnellAnmelden: string;
	readonly cadAnfragen: string;
}

interface BaseEnvironment {
	readonly native: boolean;
	readonly inocon?: true;
	readonly landKuerzelHeaderName: string;
	readonly landKuerzel: string;
	readonly identityCulture: string;
	readonly friendlyCaptchaSitekey: string;

	readonly notification?: Notification;
}

interface NormblattEnvironment {
	readonly normblattGuid: string;
	readonly cadenasCatalog: string;
	readonly cadenasLanguage: string;
	readonly cadenasApiKey: string;
	readonly cadenasApiUrl: string;
	readonly cadenasServerType: string;
}

interface NormblattUebersichtEnvironment {
	readonly globalerFilterData: GlobalerFilterData;
}

// Partial macht alle props nullable => sind nur auf spezifischen Seiten verfügbar
type Environment = BaseEnvironment
	& Partial<NormblattEnvironment>
	& Partial<NormblattUebersichtEnvironment>;

/** Bildet die ApiEndpoints des Servers ab. Diese werden im Layout bereitgestellt. */
export const apiEndpoints = readJsonBlob<ApiEndpoints>("nova-api-endpoints");

/** Bildet Umgebungsvariablen ab. Diese werden im Layout und ggf. einzelnen Views bereitgestellt. */
export const environment = readJsonBlob<Environment>("nova-environment");

const localizedStrings = readJsonBlob<{ [key: string]: string; }>("nova-localization");

/** Ermittelt Sprachcodes. Diese werden im Layout und ggf. einzelnen Views bereitgestellt. */
export function localization(key: string): string {
	return localizedStrings[key] ?? "#" + key;
}

function readJsonBlob<T extends object>(id: string): T {
	let json = document.getElementById(id)?.innerText;

	if (!json) {
		console.warn(`kein JSON blob für id ${id} gefunden`);
		return {} as T;
	}

	return JSON.parse(json);
}
